import React from 'react';
import { ArchiveIcon, CheckCircle2Icon, PencilIcon, PlusIcon } from 'lucide-react';
import { AppUser, settingsActions, useSettingsStore } from '../../data/settingsStore';
type UsersTabProps = {
  onNewUser: () => void;
  onEditUser: (user: AppUser) => void;
};
export function UsersTab({
  onNewUser,
  onEditUser
}: UsersTabProps) {
  const {
    users
  } = useSettingsStore();
  return <section className="overflow-hidden rounded-xl border border-slate-200" data-id="element-359" data-mp="38770tv805hqt">
      <div className="flex flex-col gap-3 border-b border-slate-200 bg-white px-4 py-4 sm:flex-row sm:items-center sm:justify-between md:px-5" data-id="element-360" data-mp="3d5s1twv2w5gb">
        <div data-id="element-361" data-mp="3i3ths8x7jonk">
          <h2 className="text-base font-semibold text-slate-900" data-id="element-362" data-mp="3i3a1sxr4bac6">Users</h2>
          <p className="mt-0.5 text-sm text-slate-500" data-id="element-363" data-mp="3n47qzuajp4n6">
            Manage who can access the platform.
          </p>
        </div>
        <button type="button" onClick={onNewUser} className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#14466B] px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-[#0F3D5C]" data-id="element-364" data-mp="xeck3zzntubv">
          <PlusIcon className="h-4 w-4" data-id="element-365" data-mp="1d69ybhtcawnh" />
          Add new user
        </button>
      </div>
      <div className="overflow-x-auto" data-id="element-366" data-mp="194eua5k0y560">
        <table className="min-w-[880px] w-full text-left" data-id="element-367" data-mp="193dbfewroedq">
          <thead className="border-b border-slate-200 bg-slate-50" data-id="element-368" data-mp="146mtsn5bdaq7">
            <tr data-id="element-369" data-mp="z6qp0loslf9l">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-370" data-mp="z6h0z3nb5i6j">
                Profile picture
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-371" data-mp="uepilgeb2irh">
                First name
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-372" data-mp="lfvn5tcpnyfi">
                Last name
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-373" data-mp="gfhec93ackgf">
                Email address
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-374" data-mp="1t0u25smpooe">
                Role
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-375" data-mp="6tybgg5teeou">
                Hourly cost
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-376" data-mp="3sz1yhvi39k12">
                Status
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right" data-id="element-377" data-mp="kktl3uo50zth">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white" data-id="element-378" data-mp="atp6wx6adizp">
            {users.map(user => <tr key={user.id} className="hover:bg-slate-50" data-id="element-379" data-mp="friffwv2ap35">
                <td className="px-4 py-3" data-id="element-380" data-mp="13inwgfcqnnf1">
                  <Avatar user={user} data-id="element-381" data-mp="13gt6gmmm1543" />
                </td>
                <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-382" data-mp="18anycdcdcqe9">
                  {user.firstName}
                </td>
                <td className="px-4 py-3 text-sm text-slate-700" data-id="element-383" data-mp="2sy6t3v8fstbn">
                  {user.lastName}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600" data-id="element-384" data-mp="32put4kj27ioq">
                  {user.email}
                </td>
                <td className="px-4 py-3" data-id="element-385" data-mp="2xq83tcpyibzk">
                  <RoleBadge role={user.role} data-id="element-386" data-mp="2xr9qyfk8yoxn" />
                </td>
                <td className="px-4 py-3 text-right text-sm font-semibold tabular-nums text-slate-900" data-id="element-387" data-mp="2a0dtp2x0v1j0">
                  £{user.hourlyCost.toFixed(2)}
                </td>
                <td className="px-4 py-3" data-id="element-388" data-mp="2j1vegyldjre1">
                  <StatusBadge status={user.status} data-id="element-389" data-mp="2j2n31pgk0out" />
                </td>
                <td className="px-4 py-3 text-right" data-id="element-390" data-mp="2ezqn66ief6uk">
                  <div className="inline-flex items-center gap-2" data-id="element-391" data-mp="2f2cymh8eu6i2">
                    <button type="button" onClick={() => onEditUser(user)} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-[#14466B] transition-colors hover:bg-slate-50" data-id="element-392" data-mp="3ufpi2g3096cv">
                      <PencilIcon className="h-3.5 w-3.5" data-id="element-393" data-mp="tnvsy2t6vmio" />
                      Edit
                    </button>
                    <button type="button" onClick={() => settingsActions.toggleUserStatus(user.id)} className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-medium transition-colors ${user.status === 'active' ? 'border-amber-200 text-amber-700 hover:bg-amber-50' : 'border-emerald-200 text-emerald-700 hover:bg-emerald-50'}`} data-id="element-394" data-mp="yn8qbhhosbzi">
                      {user.status === 'active' ? <ArchiveIcon className="h-3.5 w-3.5" data-id="element-395" data-mp="1mcb9itryycw4" /> : <CheckCircle2Icon className="h-3.5 w-3.5" data-id="element-396" data-mp="1r7qhx677jgl5" />}
                      {user.status === 'active' ? 'Archive' : 'Reactivate'}
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}
function Avatar({
  user
}: {
  user: AppUser;
}) {
  const initials = `${user.firstName.slice(0, 1)}${user.lastName.slice(0, 1)}`.toUpperCase();
  return <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-[#14466B] text-xs font-semibold text-white" data-id="element-397" data-mp="31v9682qi8xvr">
      {user.profileUrl ? <img src={user.profileUrl} alt={`${user.firstName} ${user.lastName}`} className="h-full w-full object-cover" data-id="element-398" data-mp="3uj506zoowbou" /> : initials}
    </span>;
}
function RoleBadge({
  role
}: {
  role: AppUser['role'];
}) {
  return <span className="inline-flex whitespace-nowrap rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-[#14466B]" data-id="element-399" data-mp="m2tpdtr9aw2i">
      {role}
    </span>;
}
function StatusBadge({
  status
}: {
  status: 'active' | 'archived';
}) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${status === 'active' ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600'}`} data-id="element-400" data-mp="2bjxm1es1gd4d">
      <span className={`h-1.5 w-1.5 rounded-full ${status === 'active' ? 'bg-emerald-500' : 'bg-slate-400'}`} data-id="element-401" data-mp="21t2v3x3ukpcl" />
      {status === 'active' ? 'Active' : 'Archived'}
    </span>;
}